export function shouldApplyPollResult(
  requestId: number,
  currentRequestId: number,
  aborted: boolean,
): boolean {
  return !aborted && requestId === currentRequestId;
}

export function pipelineStageKey(stage?: string | null): string {
  return stage ? `processing.pipelineStages.${stage}` : '';
}

export function canRetryJob(status?: string | null): boolean {
  return status === 'DeadLettered';
}
